module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/qa/female_consulter_unanswered-bd0343978c6da06103810ffb674615f4.png";